/*eslint-disable*/
import Button from "@material-ui/core//Button";
import Grid from "@material-ui/core/Grid";
import MobileStepper from "@material-ui/core/MobileStepper";
import GridItem from "components/Grid/GridItem.jsx";
import gql from "graphql-tag";
import {
  GetUserId,
  GetUserKey,
  GetUserToken,
  Logout
} from "helpers/UserHelper";
import TaxCalculator from "helpers/TaxCalculator";
import moment from "moment";
import React, { Component } from "react";
import { graphql } from "react-apollo";
import { successWarning, showSnack } from "reducers/NotificationReducer";
import { change, reduxForm, reset, untouch } from "redux-form";
import store from "store";
import CC_bankDetail from "./CC_bankDetail.jsx";
import CC_clientForm from "./CC_clientForm.jsx";
import CC_clientOccForm from "./CC_clientOccForm.jsx";
import CC_contactDetails from "./CC_contactDetails.jsx";
import CC_healthInfo from "./CC_healthInfo.jsx";
import CC_willDetail from "./CC_willDetail.jsx";
import { getClientsByBroker } from "queries/clientsByBroker";
import { imageTypes, validateFile } from "helpers/Documents.js";
import { fileUploadServerPath } from "constants.js";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { createUploadLink } from "apollo-upload-client";
import { ParseDMYwSlashes } from "helpers/DateHelpers";
import _ from "lodash";

const uploadClient = new ApolloClient({
  link: createUploadLink({ uri: fileUploadServerPath }),
  cache: new InMemoryCache()
});

const form = "client";

const clientCreate = gql`
  mutation clientCreate($input: ClientCreateInput!) {
    ClientCreate(input: $input) {
      clientMutationId
      client {
        id
        scd_name
        scd_surname
        scd_email
        date_created
        scd_clientType
        scd_registered
        invite_sent
        app_info_complete
        status
      }
      clientId
    }
  }
`;

const uploadFileMutation = gql`
  mutation($file: Upload!, $id: String!) {
    uploadClientAvatar(file: $file, id: $id)
  }
`;

class ClientForm extends Component {
  constructor(props) {
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.state = {
      firstName: "",
      lastName: "",
      secondName: "",
      initials: "",
      page: 0,
      pageCount: 6,
      checkValidation: false,
      afterTaxIncome: "0",
      married: false,
      saCitizen: true,
      file: null,
      imgSrc: null,
      initialId: "",
      occupationValid: true
    };
  }

  componentDidMount() {
    this.props.initialize({
      Admin: "100",
      Travel: "0",
      ManualLabour: "0",
      Supervision: "0",
      idType: "idNumber"
    });
  }

  componentWillUnmount() {
    store.dispatch(reset("client"));
    store.dispatch(
      showSnack({
        open: false
      })
    );
  }

  toggleOccupationValid = valid => {
    this.setState({ occupationValid: valid });
  };

  changeFirstName(name) {
    if (name && name !== "") {
      let initials = "";
      initials =
        name.substring(0, 1).toUpperCase() +
        this.state.secondName.substring(0, 1).toUpperCase();

      store.dispatch(change("client", "initials", initials));
      this.setState({ firstName: name });
    }
  }

  changeSecondName(name) {
    if (name && name !== "") {
      let initials = "";
      initials =
        this.state.firstName.substring(0, 1).toUpperCase() +
        name.substring(0, 1).toUpperCase();

      store.dispatch(change("client", "initials", initials));
      this.setState({ secondName: name });
    }
  }

  changeLastName(name) {
    this.setState({ lastName: name });
  }

  checkAssistantActive() {
    return GetUserKey("userType") === "6" ? true : false;
  }

  getBrokerId = () => {
    let brokerId = GetUserId();
    if (this.checkAssistantActive()) {
      brokerId = sessionStorage.getItem("ActiveBrokerId");
    }
    return brokerId;
  };

  submit = () => {
    if (this.state.page === 2 && !this.state.occupationValid) {
      store.dispatch(
        showSnack({
          message: "Invalid Occupation",
          color: "danger"
        })
      );
      return;
    }
    if (store.getState().form[form].syncErrors) {
      store.dispatch(
        showSnack({
          message: "Invalid Information",
          color: "danger"
        })
      );
      this.setState({ checkValidation: true });
      this.forceUpdate();
    } else if (this.checkOccupationDuties()) {
      store.dispatch(
        showSnack({
          message: "Occupational Duties must add up to 100%",
          color: "danger"
        })
      );
    } else {
      this.setState({ checkValidation: false });

      var dat = store.getState().form[form].values;
      dat.calculatedMonthlyIncomeAT = this.state.afterTaxIncome;
      dat.actualMonthlyIncomeAT = this.state.afterTaxIncome;

      var input = {
        data: dat,
        token: GetUserToken()
      };

      input.data["brokerId"] = this.getBrokerId();

      this.props
        .mutate({
          variables: {
            input
          }
        })
        .then(resp => {
          var clientId = resp.data.ClientCreate.clientId;
          store.dispatch(
            successWarning({
              open: true,
              title: "Client Created.",
              onConfirm: () =>
                this.props.history.push({
                  pathname: "/app/ManageClients"
                })
            })
          );

          if (this.state.file !== null) {
            uploadClient
              .mutate({
                mutation: uploadFileMutation,
                variables: {
                  file: this.state.file,
                  id: clientId
                }
              })
              .then(console.log("profile picture updated"));
          }
        })
        .catch(error => {
          if (error.toString().includes("invalid token")) {
            Logout();
            this.props.history.push({
              pathname: "/app/portal/login"
            });
          }
          store.dispatch(
            showSnack({
              message: "There was an error creating this new client : " + error,
              color: "danger"
            })
          );
        });
    }
  };

  checkOccupationDuties = () => {
    var clientForm = store.getState().form[form].values;
    if (
      this.state.page === 2 &&
      parseInt(clientForm.Admin) +
        parseInt(clientForm.Travel) +
        parseInt(clientForm.ManualLabour) +
        parseInt(clientForm.Supervision) !==
        100
    ) {
      return true;
    }
    return false;
  };

  nextPage() {
    if (this.state.page === 2 && !this.state.occupationValid) {
      store.dispatch(
        showSnack({
          message: "Invalid Occupation",
          color: "danger"
        })
      );
      return;
    }
    if (this.checkOccupationDuties()) {
      store.dispatch(
        showSnack({
          message: "Occupational Duties must add up to 100%.",
          color: "danger"
        })
      );
    } else {
      if (store.getState().form[form].syncErrors) {
        store.dispatch(
          showSnack({
            message: "Invalid Information.",
            color: "danger"
          })
        );
        this.setState({ checkValidation: true });
        this.forceUpdate();
      } else {
        this.setState({ page: this.state.page + 1, checkValidation: false });
        this.forceUpdate();
      }
    }
  }

  previousPage() {
    if (this.state.page === 2 && !this.state.occupationValid) {
      store.dispatch(
        showSnack({
          message: "Invalid Occupation",
          color: "danger"
        })
      );
      return;
    }
    this.setState({ page: this.state.page - 1 });
  }

  onSalaryChange(value) {
    value = value
      .toString()
      .replace(/,/g, "")
      .replace(/ /g, "");
    if (value === "" || isNaN(Number(value))) {
      return;
    }
    var x = TaxCalculator(
      parseFloat(value),
      _.get(store.getState().form, "client.values.age", null)
    );

    x = x.toString();

    //let parsed = parseFloat(val);

    this.setState({ afterTaxIncome: x.toString() });
    this.forceUpdate();

    if (
      store.getState().form.client.fields &&
      store.getState().form.client.fields.actualMonthlyIncomeAT &&
      store.getState().form.client.fields.actualMonthlyIncomeAT.touched
    ) {
      return;
    } else {
      store.dispatch(change("client", "actualMonthlyIncomeAT", x.toString()));
      store.dispatch(untouch("client", "actualMonthlyIncomeAT"));
    }
  }

  maritalChangeHandler = value => {
    if (value === "Married") {
      this.setState({ married: true });
      if (store.getState().form.client.values.title === "MISS") {
        store.dispatch(change("client", "title", "MRS"));
      }
    } else {
      if (value !== "validationError") {
        if (store.getState().form.client.values.title === "MRS") {
          store.dispatch(change("client", "title", "MISS"));
        }
      }
      store.dispatch(change("client", "spouseIncome", ""));
      this.setState({ married: false });
    }
  };

  resetclientIdDetails() {
    store.dispatch(change("client", "said", ""));
    store.dispatch(untouch("client", "said"));

    store.dispatch(change("client", "passportNumber", ""));
    store.dispatch(untouch("client", "passportNumber"));
  }

  idChangeHandler = value => {
    if (value === "idNumber") {
      if (!this.state.saCitizen) {
        this.resetclientIdDetails();
      }
      this.setState({ saCitizen: true });
    } else {
      if (this.state.saCitizen) {
        this.resetclientIdDetails();
      }
      this.setState({ saCitizen: false });
    }
  };

  dobChanged = val => {
    try {
      if (val.length !== 10) throw "Too short";
      var dob = ParseDMYwSlashes(val);
      var age = moment().diff(dob, "years");
      store.dispatch(change("client", "age", age));
    } catch (error) {
      store.dispatch(change("client", "age", ""));
    }
    this.forceUpdate();
  };

  withoutClasses(props) {
    let newProps = { ...props };
    delete newProps.classes;
    return newProps;
  }

  fileAttached = file => {
    var valid = validateFile(file.name, imageTypes);
    if (!valid) {
      store.dispatch(
        showSnack({
          message: "Invalid file type.",
          color: "danger"
        })
      );
    } else {
      this.setState({ file: file, imgSrc: URL.createObjectURL(file) });
    }
  };

  render() {
    const { page } = this.state;

    return (
      <Grid container>
        <GridItem
          xs={12}
          sm={12}
          md={10}
          style={{ margin: "auto", width: "100%" }}
        >
          <div className={"fixedStepper"}>
            <Grid container>
              <GridItem xs={12} sm={12} md={10} style={{flexBasis: "100%", maxWidth: "100%", margin: 'auto' }}>
                <div className={"stepperDiv"}>
                  <MobileStepper
                    type="progress"
                    steps={this.state.pageCount}
                    position="static"
                    activeStep={this.state.page}
                    nextButton={
                      <div style={{ display: "flex" }}>
                        {this.state.page > 1 ? (
                          <Button
                            variant="outlined"
                            className="outlinedButton"
                            color="secondary"
                            style={{ marginRight: "10px" }}
                            onClick={() => this.submit()}
                          >
                            Submit
                          </Button>
                        ) : (
                          <div />
                        )}

                        <Button
                          variant="outlined"
                          className="outlinedButton"
                          color="secondary"
                          style={{ marginRight: "10px" }}
                          onClick={() => this.nextPage()}
                          disabled={
                            this.state.page === this.state.pageCount - 1
                              ? true
                              : false
                          }
                        >
                          Next
                        </Button>
                      </div>
                    }
                    backButton={
                      <Button
                        variant="outlined"
                        className="outlinedButton"
                        color="secondary"
                        style={{ marginLeft: "10px" }}
                        onClick={() => this.previousPage()}
                        disabled={this.state.page === 0 ? true : false}
                      >
                        Back
                      </Button>
                    }
                  />
                </div>
              </GridItem>
            </Grid>
          </div>

          <br />
          {page === 0 && (
            <CC_clientForm
              previousPage={this.previousPage}
              changeFirstName={this.changeFirstName.bind(this)}
              changeLastName={this.changeLastName.bind(this)}
              changeSecondName={this.changeSecondName.bind(this)}
              idChangeHandler={this.idChangeHandler.bind(this)}
              maritalChangeHandler={this.maritalChangeHandler.bind(this)}
              fileAttached={this.fileAttached}
              dobChanged={this.dobChanged}
              {...this.withoutClasses(this.props)}
              {...this.state}
            />
          )}
          {page === 1 && (
            <CC_contactDetails
              previousPage={this.previousPage}
              checkValidation={this.state.checkValidation}
              {...this.withoutClasses(this.props)}
            />
          )}
          {page === 2 && (
            <CC_clientOccForm
              previousPage={this.previousPage}
              onSubmit={this.submit}
              salaryChangeHandler={this.onSalaryChange.bind(this)}
              toggleOccupationValid={this.toggleOccupationValid}
              {...this.withoutClasses(this.props)}
              {...this.state}
            />
          )}
          {page === 3 && (
            <CC_bankDetail
              previousPage={this.previousPage}
              onSubmit={this.submit}
              {...this.withoutClasses(this.props)}
              {...this.state}
            />
          )}
          {page === 4 && (
            <CC_healthInfo
              previousPage={this.previousPage}
              onSubmit={this.submit}
              {...this.withoutClasses(this.props)}
              {...this.state}
            />
          )}
          {page === 5 && (
            <CC_willDetail
              previousPage={this.previousPage}
              onSubmit={this.submit}
              {...this.withoutClasses(this.props)}
              {...this.state}
            />
          )}
        </GridItem>
      </Grid>
    );
  }
}

ClientForm = reduxForm({
  form: form,
  destroyOnUnmount: true
})(ClientForm);

ClientForm = graphql(clientCreate, {
  options: {
    update: (proxy, { data: { clientCreate } }) => {
      const { clients } = proxy.readQuery({ query: getClientsByBroker });

      proxy.writeQuery({
        getClientsByBroker,
        data: clients.concat(clientCreate.client)
      });
    }
  }
})(ClientForm);

export default ClientForm;



// WEBPACK FOOTER //
// ./src/views/Clients/components/ClientForm.jsx